/* eslint-disable import/order */
//import '@/@fake-db/db'
import '@/@iconify/icons-bundle'
import App from '@/App.vue'
import layoutsPlugin from '@/plugins/layouts'
import vuetify from '@/plugins/vuetify'
import { loadFonts } from '@/plugins/webfontloader'
import router from '@/router'
import '@core/scss/template/index.scss'
import '@styles/styles.scss'
import '@styles/sensando-tokens.css'
import '@styles/sensando-utilities.scss'
import '@/plugins/echarts-theme'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import i18nPlugin from '@/plugins/i18n'

import * as Sentry from "@sentry/vue";

// Vue router compatibility plugin
import 'unplugin-vue-router/runtime';

loadFonts()

// Create vue app
const app = createApp(App)

// Sentry init
Sentry.init({
  app,
  dsn: "https://ea56b11cd138cfb54a3bfc65a7841ff5@o4510806139469824.ingest.us.sentry.io/4510806141239296",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Logs
  enableLogs: true
});

// Use plugins
app.use(createPinia())
app.use(router)
app.use(vuetify)
app.use(layoutsPlugin)
app.use(i18nPlugin)

// Mount vue app
app.mount('#app')
